<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CNCT ParaOverride-11" id="_idParaDest-6"><span class="CharOverride-9">We stand upon the brink of a precipice. We peer into the abyss—we grow sick and dizzy. Our first impulse is to shrink from the danger. Unaccountably we remain.</span></p>
<p class="BT1stPara ParaOverride-12"><span class="CharOverride-10">Edgar Allan Poe, “The Imp of the Perverse”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43525.vue?2d6b0934